<template>
  <lists :suppress="0" />
</template>

<script>
import Lists from '@/modules/audiences/pages/BaseLists'
export default {
  components: { Lists }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/pages/UserLists.vue